import React from 'react';
import isEmpty from 'lodash/isEmpty';
import {CONFIG, I18N} from '../globals/config';
import Item from './history/Item';
import {ThickboxInteractions, withModal} from './modals/thickbox';

import styles from './history.pcss';
import {isMobile} from '../helpers/device';

export interface HistoryItem {
	date: string;
	id: string;
	new: string;
	old: string;
}

interface Props extends ThickboxInteractions {
}


const History = ( {close}: Props ) => {
	return (
		<div className={styles.wrap}>
			{isEmpty( CONFIG.history ) && <div className={styles.empty}>
				{I18N.history_empty}
			</div>}
			{! isEmpty( CONFIG.history ) && <div className={styles.header}>
				<div className={styles.old}>
					{I18N.oldUrl}
				</div>
				<div className={styles.new}>
					{I18N.newUrl}
				</div>
				<div className={styles.date}>
					{I18N.date}
				</div>
				<div className={styles.action}>
					&nbsp;
				</div>
			</div>}

			{CONFIG.history.map( ( item: HistoryItem ) => (
				<Item item={item} key={item.id} closeModal={close} />
			) )}
			<button className={styles.button + ' button-primary'} onClick={close}>
				{I18N.closeHistory}
			</button>
		</div>
	);
};

export default withModal<Props>( History, {
	width: 800,
	height: isMobile() ? 520 : 540,
	title: I18N.history,
} );
